/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'

import axios from 'axios'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'

import NavDashboard from '../common/NavDashboard'
import ProfileOverview from './profiles/ProfileOverview'
import Media from './media/Media'
import Bio from './bio/Bio'
import FeedbackRequests from './feedbackRequests/FeedbackRequests'
import ReviewerBio from './reviewerBio/ReviewerBio'

import useWindowDimensions from '../../helpers/windowDimensions'
import { userIsAuthenticated, getTokenFromLocalStorage, getPayload, getIsReviewerFromLocalStorage } from '../../helpers/storage'
import { standardSpinner } from '../../helpers/spinners'
import { couldNotLoadPageError } from '../../helpers/errors'
import { navbarHeight, footerHeight, dashboardNavbarHeight } from '../../helpers/variableDefaults'
import { reloadView, dummyBox } from '../../helpers/globalHelpers'

// Dashboard Page
const Dashboard = (props) => {

  const { isDemo, demoUser } = props
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()
  
  // Navigate
  const navigate = useNavigate()
  // console.log('navigate ->', navigate(-1))
  // console.log('window.history ->', window.history)
  const location = useLocation()
  // console.log('location ->', location)
  const previousLocationPathname = 'state' in location && location.state !== null && location.state !== undefined && 'previousLocationPathname' in location.state ? location.state.previousLocationPathname : ''
  // console.log('state' in location)
  // console.log('state' in location && location.state !== null && location.state !== undefined)
  // console.log('state' in location && location.state !== null && location.state !== undefined && 'previousLocationPathname' in location.state)
  // console.log('previousLocationPathname ->', previousLocationPathname)


  // Params
  const { userId } = useParams()

  // Payload
  const payload = getPayload()

  // Is Reviewer?
  // const isReviewer = getIsReviewerFromLocalStorage() ? true : false
  const isReviewer = isDemo ? false : getIsReviewerFromLocalStorage() !== null && getIsReviewerFromLocalStorage() === 'true' ? true : false
  // console.log('isReviewer typeof ->', typeof isReviewer)
  // console.log('isReviewer ->', isReviewer)

  // Dashboard Navigation
  const [user, setUser] = useState(isDemo ? { ...demoUser } : {})
  const [viewIndex, setViewIndex] = useState(previousLocationPathname && (previousLocationPathname.includes('media-item') || previousLocationPathname.includes('view-past-review') || previousLocationPathname.includes('crop-media')) ? 1 : 0)

  // Loading
  const [loading, setLoading] = useState(false)

  // Errors
  const [errors, setErrors] = useState(false)

  useEffect(() => {
    // console.log('viewIndex useEffect Runs')

  }, [viewIndex])


  return (
    <>
      {loading ?
        <Box sx={{ 
          width: '100vw', minWidth: '100vw',
          // minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`,
          minHeight: `calc(100vh - ${navbarHeight})`,
          mt: 0, mb: 0,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
        }}>
          {dummyBox(`${dashboardNavbarHeight}px`)}
          {standardSpinner()}
        </Box>
        :
        <Box
          sx={{
            width: '100vw', minWidth: '100vw',
            minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight})`,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start',
          }}
        >
          {/* Navigation  */}
          <NavDashboard 
            isDemo={isDemo}
            userId={userId} 
            userIsReviewer={isReviewer} 
            viewIndex={viewIndex} 
            setViewIndex={setViewIndex} 
            setLoading={setLoading} 
          />
          
          {/* Client Views */}
          {/* Profiles */}
          {viewIndex === 0 && !isReviewer &&
            <ProfileOverview isDemo={isDemo} demoUser={user} />
          }

          {/* Media */}
          {viewIndex === 1 && !isReviewer &&
            <Media isDemo={isDemo} demoUser={user} />
          }

          {/* Bio */}
          {viewIndex === 2 && !isReviewer &&
            <Bio isDemo={isDemo} demoUser={user} />
          }
          
          {/* Reviewer Views */}
          {/* New Requests */}
          {viewIndex === 0 && isReviewer &&
            <FeedbackRequests viewIndex={0} />
          }

          {/* History */}
          {viewIndex === 1 && isReviewer &&
            <FeedbackRequests viewIndex={1} />
          }

          {/* Reviewer Bio */}
          {viewIndex === 2 && isReviewer &&
            <ReviewerBio />
          }
        </Box>
      }

    </>
  )
}

export default Dashboard